import React, { Component, Fragment } from "react";
import { Route, Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import AccountStats from "./../account_stats/";
import Logo from "./../shared/ui/logo";
import { Breadcrumbs } from "react-breadcrumbs-dynamic";

import {
  debounced,
  checkAccessTokenExpirationTime,
} from "./../../utils/helpers/common";
import { internalRoutesArray } from "./internal_routing";
import "./css/style.scss";

import * as actionsAccountStats from "./../account_stats/actions";
import * as actionsCreatorAuth from "../../store/root_actions/auth";

class PlatformLanding extends Component {
  componentDidMount = () => {
    document.body.classList.add("platform-style");
  };

  componentWillUnmount = () => {
    document.body.classList.remove("platform-style");
  };

  handleAuthModal = () => {
    this.props.authModalState(true);
  };

  handleAccountStats = () => {
    const isAccessTokenExpired = checkAccessTokenExpirationTime(
      this.props.accessTokenExprirationTime
    );

    if (isAccessTokenExpired && !this.props.accountStats) {
      this.props.authRefresh("mainHeader", null);
    } else {
      if (!this.props.accountStats) {
        this.props.checkAccountStatsInfo();
      }
    }

    this.props.toggleAccountStatus(!this.props.accountStats);
  };

  render() {
    let {
      signIn,
      accountStats,
      videoLessonsSubscription,
      examPreparationSubscription,
    } = this.props;

    if (videoLessonsSubscription === null) {
      videoLessonsSubscription =
        localStorage.getItem("easyMath") !== null
          ? JSON.parse(localStorage.getItem("easyMath"))
              .videoLessonsSubscription
          : false;
    }

    if (examPreparationSubscription === null) {
      examPreparationSubscription =
        localStorage.getItem("easyMath") !== null
          ? JSON.parse(localStorage.getItem("easyMath"))
              .examPreparationSubscription
          : false;
    }

    let isSubsCriptionActive = false;
    let currentPath = this.props.location.pathname;
    let youveHitVideo = currentPath.includes("video-tutor") ? true : false;
    let youveHitExam = currentPath.includes("math-tutor") ? true : false;
    let youveHitContest = currentPath.includes("contest") ? true : false;

    if (youveHitVideo) {
      isSubsCriptionActive = videoLessonsSubscription;
    } else if (youveHitExam) {
      isSubsCriptionActive = examPreparationSubscription;
    } else {
      isSubsCriptionActive =
        videoLessonsSubscription || examPreparationSubscription ? true : false;
    }

    let content = null;
    content = (
      <div
        className="wrapper platform-paddings"
        onContextMenu={(e) => e.preventDefault()}
      >
        <div className="platform-wrapper">
          <header className="text-center platform-header">
            <Link to="/" className="platform-home-button">
              <Logo />
            </Link>
            <button
              data-tip="Назад"
              onClick={this.props.history.goBack}
              className="platform-header-button back-button"
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            <Link
              data-tip="Начало"
              to={this.props.match.url + "/intro"}
              className="platform-header-button home-button"
            >
              <i className="fas fa-home"></i>
            </Link>
            <button
              data-tip="Акаунт"
              className={`platform-header-button account-button ${
                signIn && isSubsCriptionActive ? "active" : "inactive"
              }`}
              onClick={
                signIn
                  ? debounced(300, this.handleAccountStats)
                  : debounced(500, this.handleAuthModal)
              }
            >
              <i className="fas fa-user"></i>
            </button>
            <Link
              data-tip="Изход"
              to="/"
              className="platform-header-button exit-button"
            >
              <i className="fas fa-door-open"></i>
            </Link>
            {accountStats && <AccountStats />}
            <ReactTooltip
              place="bottom"
              backgroundColor="#FFC530"
              textColor="#055187"
              effect="solid"
              className="platform-header-tooltip"
            />
          </header>
          <div className="platform-breadcrumbs">
            {youveHitVideo && (
              <Fragment>
                <Link
                  to={this.props.match.url + "/video-tutor"}
                  className="breadcrumb-made-byhand"
                >
                  Видео уроци
                </Link>
              </Fragment>
            )}
            {youveHitExam && (
              <Fragment>
                <Link
                  to={this.props.match.url + "/math-tutor"}
                  className="breadcrumb-made-byhand"
                >
                  Онлайн подготовка за състезания
                </Link>
              </Fragment>
            )}
            {youveHitContest && (
              <Fragment>
                <Link
                  to={this.props.match.url + "/intro"}
                  className="breadcrumb-made-byhand"
                >
                  Онлайн състезание
                </Link>
              </Fragment>
            )}
            <Breadcrumbs duplicateProps={{ to: "href" }} />
          </div>
          {internalRoutesArray.map((item, index) => (
            <Route
              key={"internal" + index}
              exact={item.exact}
              path={this.props.match.url + item.path}
              component={item.mainComponent}
            />
          ))}
        </div>
      </div>
    );

    return <Fragment> {content} </Fragment>;
  }
}

const mapStateToProps = ({ authedUser, accountStats }) => {
  return {
    signIn: authedUser.signIn,
    accessTokenExprirationTime: authedUser.accessTokenExprirationTime,
    accountStats: accountStats.accountStats,
    videoLessonsSubscription: authedUser.videoLessonsSubscription,
    examPreparationSubscription: authedUser.examPreparationSubscription,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ...actionsAccountStats,
      ...actionsCreatorAuth,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PlatformLanding);
